import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconZoomLogo",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, o, u, f, a) {
  return i(), d("svg", {
    "aria-label": o.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--zoom-logo"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Zoom Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    n("path", {
      fill: "currentColor",
      d: "M2 3.5a.5.5 0 0 0-.5.5v3.222a1.5 1.5 0 0 0 1.5 1.5h4.646a.5.5 0 0 0 .5-.5V5a1.5 1.5 0 0 0-1.5-1.5H2Zm6.796 1.298a.5.5 0 0 0-.175.38V7.28a.5.5 0 0 0 .175.38l1.255 1.07a.5.5 0 0 0 .824-.38V4.11a.5.5 0 0 0-.824-.38L8.796 4.8Z"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=zoom-logo.js.map
